export default __webpack_public_path__ + "static/media/upload-concierge-icon.5ca734f1.png";